export const LAST_WEEK = "LAST_WEEK"
export const CURRENT_WEEK = "CURRENT_WEEK"
export const NEXT_WEEK = "NEXT_WEEK"